import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Button from '../Button/Button.jsx';
import Overlay from './Modal.style.js';
import { Content, ButtonWrapper } from './Modal.style.js';

const ModalContainer = ({ id, children, callback }) => {
  const modalRoot = document.getElementById(id);
  const element = document.createElement('div');

  useEffect(() => {
    modalRoot.appendChild(element);
    disableBodyScroll(modalRoot);

    return () => {
      modalRoot.removeChild(element);
      enableBodyScroll(modalRoot);
    };
  });

  return createPortal(
    <>
      <ButtonWrapper>
        <Button type="circle" size="large" icon="cross" variant="tan" onClick={() => callback()} />
      </ButtonWrapper>
      <Overlay onClick={() => callback()} />
      <Content>{children}</Content>
    </>,
    element
  );
};

const Modal = ({ id = 'modal-container', children, className = '', callback = () => {} }) => {
  // Use state to track if component has been mounted after hydration
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // During SSR or first render return a placeholder div with the same className
  // This ensures server and client render the same initial content
  if (!isMounted) {
    return <div className={className} style={{ display: 'none' }} data-modal-placeholder />;
  }

  // After hydration is complete and component is mounted, render the actual modal
  return (
    <ModalContainer id={id} className={className} callback={callback}>
      {children}
    </ModalContainer>
  );
};

export default Modal;